import {IconButton} from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import React, {useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';
import Swal from 'sweetalert2';
import {
  createCategory,
  createDrugInventory,
  createVendor,
  deleteCategory,
  deleteVendor,
  getCategories,
  getDrugInventory,
  getVendors,
  updateCategory,
  updateDrugInventory,
  updateVendor
} from '../Redux/Thunk/drugInventoryActions';
import '../styles/Components/AddPatient_form.scss';

function AddDrugInventoryForm({setCloseCreatePopup, loaderchange, editData = null, categories, vendors, pagination}) {
  const dispatch = useDispatch();

  const [formData, setFormData] = useState(() =>
    editData
      ? {...editData}
      : {
          name: '',
          dosage: '',
          category: '',
          vendor: '',
          generic_name: '',
          quantity: null,
          price_per_unit: null,
          manufactured_date: null,
          expiry_date: null,
          order_date: null
        }
  );

  const [validationErrors, setValidationErrors] = useState({});

  const [selectedVendor, setSelectedVendor] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [editCategory, setEditCategory] = useState(false);
  const [editVendor, setEditVendor] = useState(false);
  const [showPopUp, setShowPopUp] = useState(false);
  const [selectedType, setSelectedType] = useState('category');
  const [openCategory, setOpenCategory] = useState(false);
  const [openVendor, setOpenVendor] = useState(false);
  const requiredFields = ['name', 'dosage', 'category'];

  useEffect(() => {
    if (editData) {
      const matchedCategory = categories.find(cat => cat.name === editData.category);
      setFormData(prev => ({
        ...prev,
        category: matchedCategory ? matchedCategory.id : ''
      }));
    }
  }, [editData, categories]);

  useEffect(() => {
    if (editData) {
      const matchedVendor = vendors.find(vendor => vendor.name === editData.vendor);
      setFormData(prev => ({
        ...prev,
        vendor: matchedVendor ? matchedVendor.id : ''
      }));
    }
  }, [editData, vendors]);

  const validateForm = () => {
    const errors = {};
    requiredFields.forEach(field => {
      if (!formData[field]) {
        errors[field] = 'This field is required';
      }
    });
    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleInputChange = e => {
    const {name, value} = e.target;
    setFormData(prev => ({...prev, [name]: value}));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    if (!validateForm()) return;
    loaderchange('true');
    const dataPayload = {
      page: pagination.pageIndex,
      page_size: pagination.pageSize
    };
    try {
      if (editData) {
        try {
          const response = await dispatch(updateDrugInventory(formData)).unwrap();

          if (response?.status?.code === 200) {
            Swal.fire({
              title: 'Successful.',
              text: 'Drug inventory updated successfully.',

              icon: 'success',
              showConfirmButton: false,
              timer: 1500
            });
            dispatch(getDrugInventory(dataPayload));
          } else {
            Swal.fire({
              title: 'Error.',
              text: 'Failed to Update drug inventory.',
              icon: 'warning',
              showConfirmButton: false,
              timer: 1500
            });
          }
        } catch (error) {
          Swal.fire({
            title: 'Error.',
            text: 'Failed to Update drug inventory.',
            icon: 'warning',
            showConfirmButton: false,
            timer: 1500
          });
        }
      } else {
        try {
          const response = await dispatch(createDrugInventory(formData)).unwrap();

          if (response?.status?.code === 201) {
            Swal.fire({
              title: 'Successful.',
              text: 'Drug inventory created successful.',
              icon: 'success',
              showConfirmButton: false,
              timer: 1500
            });
            dispatch(getDrugInventory(dataPayload));
          }
        } catch (error) {
          Swal.fire({
            title: 'Error.',
            text: 'Failed to create drug inventory.',
            icon: 'warning',
            showConfirmButton: false,
            timer: 1500
          });
        }
      }
      // setUpdate(prev => !prev);
    } catch (error) {
      console.error('Error saving drug inventory:', error);
    } finally {
      loaderchange('false');
      setCloseCreatePopup(false);
    }
  };

  const handleEdit = (id, type, flag) => {
    setOpenCategory(false);
    setOpenVendor(false);
    if (type === 'category') {
      const category = categories.find(cat => cat.id === id);
      setSelectedCategory(category);
      setEditCategory(flag);
    } else if (type === 'vendor') {
      const vendor = vendors.find(vendor => vendor.id === id);
      setSelectedVendor(vendor);
      setEditVendor(flag);
    }
    setShowPopUp(true);
    setSelectedType(type);
  };

  const handleDelete = (id, type) => {
    // setOpenCategory(false);
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
      didOpen: () => {
        document.querySelector('.swal2-container').style.zIndex = '9999';
      }
    }).then(async result => {
      if (result.isConfirmed) {
        if (type === 'category') {
          await dispatch(deleteCategory(id)).unwrap();
        } else if (type === 'vendor') {
          await dispatch(deleteVendor(id)).unwrap();
        }
        Swal.fire({
          title: 'Deleted!',
          text: `${type.charAt(0).toUpperCase() + type.slice(1)} has been deleted.`,
          icon: 'success',
          showConfirmButton: false,
          timer: 1500,
          didOpen: () => {
            const swalContainer = document.querySelector('.swal2-container');
            if (swalContainer) {
              swalContainer.style.zIndex = '99999';
              swalContainer.style.position = 'fixed';
            }
          }
        });
      }
    });
  };

  const handleAddItem = type => {
    setShowPopUp(true);
    setSelectedType(type);
  };

  return (
    <>
      <div className='adminform'>
        <div className='modal-dialog1 modal-lg' role='document'>
          <div className='modal-content modelContentChanges'>
            <div className='modal-header'>
              <h5 className='modal-title'>{`${editData ? 'Edit ' : 'Create '}`}Drug Inventory</h5>
              <button type='button' className='close' onClick={() => setCloseCreatePopup(false)}>
                <i class='bi bi-x-lg'></i>
              </button>
            </div>
            <div className='modal-body modelBodyChanges' style={{padding: '1rem', width: '920px'}}>
              <form onSubmit={handleSubmit}>
                <div className='row'>
                  <div className='col'>
                    <label className='form-label'>
                      <span style={{color: 'red'}}>*</span>Drug Name
                    </label>
                    <input type='text' className='form-control inputStyleChange' name='name' value={formData.name} onChange={handleInputChange} placeholder='Drug Name...' />
                    {validationErrors.name && <small className='text-danger'>{validationErrors.name}</small>}
                  </div>
                  <div className='col'>
                    <label className='form-label'>
                      <span style={{color: 'red'}}>*</span>Dosage
                    </label>
                    <input type='text' className='form-control inputStyleChange' name='dosage' value={formData.dosage} onChange={handleInputChange} placeholder='Dosage...' />
                    {validationErrors.dosage && <small className='text-danger'>{validationErrors.dosage}</small>}
                  </div>
                </div>
                <div className='row my-3'>
                  <div className='col'>
                    {/*  <label className='form-label'>
                    <span style={{color: 'red'}}>*</span>Category
                  </label> */}
                    {/* <select className='form-select ' name='category' value={formData.category} onChange={handleInputChange}>
                    <option value='' disabled>
                      Select Category
                    </option>
                    {category.map(category => (
                      <option key={category.id} value={category.id}>
                        {category.name}
                      </option>
                    ))}
                  </select> */}

                    <div className='col'>
                      <label className='form-label'>
                        <span style={{color: 'red'}}>*</span>Category
                      </label>
                      <div className='row'>
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '0px'
                          }}>
                          <Select
                            labelId='category-select-label'
                            value={formData.category}
                            onChange={handleInputChange}
                            name='category'
                            displayEmpty
                            fullWidth
                            open={openCategory}
                            onOpen={() => setOpenCategory(true)}
                            onClose={() => setOpenCategory(false)}
                            sx={{
                              borderRadius: '4px',
                              backgroundColor: '#fff',
                              padding: '6px 6px',
                              fontSize: '16px',
                              '&:hover .MuiOutlinedInput-notchedOutline': {
                                borderColor: '#dee2e6'
                              },
                              '& .MuiSelect-select': {
                                padding: '6px'
                              },
                              '&.Mui-focused': {
                                borderColor: '#86b7fe',
                                boxShadow: '0 0 0 0.2rem rgba(13,110,253,.25)'
                              }
                            }}
                            MenuProps={{
                              PaperProps: {
                                sx: {
                                  maxHeight: '230px', // Limit height
                                  overflowY: 'auto' // Enable scrolling
                                }
                              },
                              anchorOrigin: {
                                vertical: 'bottom',
                                horizontal: 'left'
                              },
                              transformOrigin: {
                                vertical: 'top',
                                horizontal: 'left'
                              }
                            }}
                            renderValue={selected => (selected ? categories.find(p => p.id === selected)?.name : 'Select Category')}>
                            {categories.map(category => (
                              <MenuItem
                                key={category.id}
                                value={category.id}
                                sx={{
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  padding: '0px 6px',
                                  '& span': {
                                    fontSize: '14px'
                                  }
                                }}>
                                <span>{category.name}</span>
                                <div>
                                  <IconButton
                                    size='small'
                                    onClick={e => {
                                      e.stopPropagation();
                                      handleEdit(category.id, 'category', true);
                                    }}>
                                    <i style={{marginRight: '0px'}} className='bi bi-pencil'></i>
                                  </IconButton>
                                  <IconButton
                                    size='small'
                                    onClick={e => {
                                      e.stopPropagation();
                                      handleDelete(category.id, 'category');
                                    }}>
                                    <i style={{marginRight: '0px'}} className='bi bi-trash'>
                                      {' '}
                                    </i>
                                  </IconButton>
                                </div>
                              </MenuItem>
                            ))}
                          </Select>
                          <button className='Plus mx-2' type='button' onClick={() => handleAddItem('category')}>
                            +
                          </button>
                        </div>
                      </div>
                      {validationErrors.category && <small className='text-danger'>{validationErrors.category}</small>}
                    </div>
                    {/* {validationErrors.category && <small className='text-danger'>{validationErrors.category}</small>} */}
                  </div>
                  <div className='col'>
                    <label className='form-label'>
                      <span style={{color: 'red'}}>*</span>Vendor
                    </label>
                    <div className='row'>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '0px'
                        }}>
                        <Select
                          labelId='vendor-select-label'
                          value={formData.vendor}
                          onChange={handleInputChange}
                          name='vendor'
                          displayEmpty
                          fullWidth
                          open={openVendor}
                          onOpen={() => setOpenVendor(true)}
                          onClose={() => setOpenVendor(false)}
                          sx={{
                            borderRadius: '4px',
                            backgroundColor: '#fff',
                            padding: '6px 6px',
                            fontSize: '16px',
                            '&:hover .MuiOutlinedInput-notchedOutline': {
                              borderColor: '#dee2e6'
                            },
                            '& .MuiSelect-select': {
                              padding: '6px'
                            },
                            '&.Mui-focused': {
                              borderColor: '#86b7fe',
                              boxShadow: '0 0 0 0.2rem rgba(13,110,253,.25)'
                            }
                          }}
                          MenuProps={{
                            PaperProps: {
                              sx: {
                                maxHeight: '230px', // Limit height
                                overflowY: 'auto' // Enable scrolling
                              }
                            },
                            anchorOrigin: {
                              vertical: 'bottom',
                              horizontal: 'left'
                            },
                            transformOrigin: {
                              vertical: 'top',
                              horizontal: 'left'
                            }
                          }}
                          renderValue={selected => (selected ? vendors.find(p => p.id === selected)?.name : 'Select Vendor')}>
                          {vendors.map(vendor => (
                            <MenuItem
                              key={vendor.id}
                              value={vendor.id}
                              sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                padding: '0px 6px',
                                '& span': {
                                  fontSize: '14px'
                                }
                              }}>
                              <span>{vendor.name}</span>
                              <div>
                                <IconButton
                                  size='small'
                                  onClick={e => {
                                    e.stopPropagation();
                                    handleEdit(vendor.id, 'vendor', true);
                                  }}>
                                  <i style={{marginRight: '0px'}} className='bi bi-pencil'></i>
                                </IconButton>
                                <IconButton
                                  size='small'
                                  onClick={e => {
                                    e.stopPropagation();
                                    handleDelete(vendor.id, 'vendor');
                                  }}>
                                  <i style={{marginRight: '0px'}} className='bi bi-trash'>
                                    {' '}
                                  </i>
                                </IconButton>
                              </div>
                            </MenuItem>
                          ))}
                        </Select>
                        <button className='Plus mx-2' type='button' onClick={() => handleAddItem('vendor')}>
                          +
                        </button>
                      </div>
                    </div>
                    {validationErrors.vendor && <small className='text-danger'>{validationErrors.vendor}</small>}
                  </div>
                </div>
                <div className='row my-3'>
                  <div className='col'>
                    <label className='form-label'>Generic Medicine</label>
                    <input type='text' className='form-control inputStyleChange' name='generic_name' value={formData.generic_name} onChange={handleInputChange} placeholder='Generic Medicine...' />
                    {validationErrors.generic_name && <small className='text-danger'>{validationErrors.generic_name}</small>}
                  </div>
                  <div className='col'>
                    <label className='form-label'>Quantity</label>
                    <input type='number' className='form-control inputStyleChange' name='quantity' value={formData.quantity} onChange={handleInputChange} placeholder='Enter quantity' min='1' />
                    {validationErrors.quantity && <small className='text-danger'>{validationErrors.quantity}</small>}
                  </div>

                  {/* <div className='col' style={{position: 'relative'}}>
                  <label className='form-label'>Vendor</label>
                  <input
                    type='text'
                    className='form-control inputStyleChange'
                    name='vendor'
                    value={formData.vendor}
                    onChange={handleInputChange}
                    placeholder='Type to search vendor...'
                    autoComplete='off'
                  />
                  {showDropdown && filteredVendors.length > 0 && (
                    <ul
                      className='dropdown-menu show'
                      style={{
                        width: '100%', // Ensures it matches the parent width
                        maxWidth: '95%',
                        maxHeight: '170px',
                        overflowY: 'auto',
                        position: 'absolute',
                        zIndex: 1000,
                        background: 'white',
                        border: '1px solid #ccc',
                        padding: 0
                      }}>
                      {filteredVendors.map((vendor, index) => (
                        <li
                          key={vendor.id}
                          onClick={() => handleSelectVendor(vendor)}
                          style={{
                            padding: '2px 12px',
                            cursor: 'pointer',
                            transition: 'background 0.3s'
                          }}
                          onMouseEnter={e => {
                            e.currentTarget.style.background = '#0d6efd';
                            e.currentTarget.style.color = '#ffffff'; // Change text color to white
                          }}
                          onMouseLeave={e => {
                            e.currentTarget.style.background = ''; // Reset background
                            e.currentTarget.style.color = ''; // Reset text color
                          }}>
                          {vendor.name}
                        </li>
                      ))}
                    </ul>
                  )}
                </div> */}
                </div>
                <div className='row my-3'>
                  <div className='col'>
                    <label className='form-label'>Mfg. Date</label>
                    <br />
                    <input
                      onChange={handleInputChange}
                      style={{width: '100%'}}
                      name='manufactured_date'
                      type='date'
                      autoComplete='off'
                      className='form-control inputStyleChange'
                      value={formData.manufactured_date}
                    />
                  </div>
                  <div className='col'>
                    <label className='form-label'>Exp. Date</label>
                    <br />
                    <input onChange={handleInputChange} name='expiry_date' type='date' autoComplete='off' className='form-control inputStyleChange' value={formData.expiry_date} />
                  </div>
                  <div className='col'>
                    <label className='form-label'>Order Date</label>
                    <br />
                    <input onChange={handleInputChange} name='order_date' type='date' autoComplete='off' className='form-control inputStyleChange' value={formData.order_date} />
                  </div>
                </div>
                <div className='modal-footer'>
                  <button type='submit' className='btn btn-primary'>
                    {`${editData ? 'Update ' : 'Create '}`}Drug Inventory
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {showPopUp && (
        <AddDetails
          setShowPopUp={setShowPopUp}
          selectedType={selectedType}
          editCategory={editCategory}
          setEditCategory={setEditCategory}
          selectedCategory={selectedCategory}
          setSelectedCategory={setSelectedCategory}
          editVendor={editVendor}
          setEditVendor={setEditVendor}
          selectedVendor={selectedVendor}
          setSelectedVendor={setSelectedVendor}
        />
      )}
    </>
  );
}

const AddDetails = ({setShowPopUp, selectedType, editCategory, setEditCategory, selectedCategory, setSelectedCategory, editVendor, setEditVendor, selectedVendor, setSelectedVendor}) => {
  console.log(`selectedVendor -->`, selectedVendor);
  const [categoryDetail, setCategotyDetail] = useState(selectedCategory || {id: null, name: ''});

  const [vendorDetail, setVendorDetail] = useState(
    selectedVendor || {
      id: null,
      name: ''
    }
  );

  const dispatch = useDispatch();

  const handleInputChange = e => {
    const {name, value} = e.target;
    if (selectedType === 'category') {
      setCategotyDetail(prev => ({...prev, [name]: value}));
    } else if (selectedType === 'vendor') {
      setVendorDetail(prev => ({...prev, [name]: value}));
    }
  };

  const addOrUpdate = async e => {
    e.preventDefault();
    setShowPopUp(false);
    try {
      if (selectedType === 'category') {
        if (!editCategory) {
          const response = await dispatch(createCategory({name: categoryDetail.name})).unwrap();
          Swal.fire({
            title: 'Success.',
            text: 'Category saved.',
            icon: 'success',
            showConfirmButton: false,
            timer: 1500
          });
          dispatch(getCategories());
        } else {
          dispatch(
            updateCategory({
              id: categoryDetail.id,
              name: categoryDetail.name
            })
          );
          Swal.fire({
            title: 'Success.',
            text: 'Category updated.',
            icon: 'success',
            showConfirmButton: false,
            timer: 1500
          });
          dispatch(getCategories());
        }
      } else if (selectedType === 'vendor') {
        if (!editVendor) {
          await dispatch(createVendor({name: vendorDetail.name})).unwrap();
          Swal.fire({
            title: 'Success.',
            text: 'Vendor saved.',
            icon: 'success',
            showConfirmButton: false,
            timer: 1500
          });
          dispatch(getVendors());
        } else {
          dispatch(
            updateVendor({
              id: vendorDetail.id,
              name: vendorDetail.name
            })
          );
          Swal.fire({
            title: 'Success.',
            text: 'Vendor updated.',
            icon: 'success',
            showConfirmButton: false,
            timer: 1500
          });
          dispatch(getVendors());
        }
      }
    } catch (error) {
      Swal.fire({
        title: 'Error.',
        text: 'Failed to save.',
        icon: 'warning',
        showConfirmButton: false,
        timer: 1500
      });
    }
  };
  const resetForm = () => {
    setShowPopUp(false);
    setEditCategory(false);
    setSelectedCategory(null);
    setEditVendor(false);
    setSelectedVendor(null);
    setVendorDetail({id: null, name: ''});
  };

  return (
    <div className='adminform'>
      <div className={selectedType === 'category' ? 'modal-sm' : 'modal-md'} role='document'>
        <div className='modal-content modelContentChanges'>
          <div className='modal-header'>
            <h5 className='modal-title'>{selectedType === 'category' ? 'Category' : 'Vendor Details'}</h5>
            <button type='button' className='close' data-dismiss='modal' aria-label='Close' onClick={() => resetForm()}>
              <i className='bi bi-x-lg'></i>
            </button>
          </div>
          <div
            className='modal-body modelBodyChanges'
            style={{
              padding: '1rem',
              width: selectedType === 'category' ? '480px' : '480px'
            }}>
            <form onSubmit={addOrUpdate}>
              <div className='row my-2'>
                {selectedType === 'category' ? (
                  <div className='col my-0'>
                    <label htmlFor='name' className='form-label'>
                      <span style={{color: 'red'}}>*</span>Category Name
                    </label>
                    <input
                      type='text'
                      className='form-control inputStyleChange'
                      id='name'
                      name='name'
                      autoComplete='off'
                      placeholder='Enter Category'
                      onChange={handleInputChange}
                      value={categoryDetail?.name || ''}
                    />
                  </div>
                ) : (
                  <div className='col my-0'>
                    <label htmlFor='name' className='form-label'>
                      <span style={{color: 'red'}}>*</span>Vendor Name
                    </label>
                    <input
                      type='text'
                      className='form-control inputStyleChange'
                      id='name'
                      name='name'
                      autoComplete='off'
                      placeholder='Enter Category'
                      onChange={handleInputChange}
                      value={vendorDetail?.name || ''}
                    />
                  </div>
                )}
              </div>
              <div className='modal-footer'>
                <button type='submit' className='save-button'>
                  {selectedType === 'category' ? (editCategory ? 'Update' : 'Save') : editVendor ? 'Update' : 'Save'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddDrugInventoryForm;
